import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";

@Injectable()
export class CouponService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  couponsUrl = "api/v2/coupons/";

  constructor(private httpClient: HttpClient) {}

  query(): Promise<any[]> {
    let url = `${this.couponsUrl}`;
    return this.httpClient
      .get(url)
      .toPromise()
      .then((res) => res)
      .catch(this.handleError);
  }

  create(percentageOff: number): Promise<any> {
    const url = `${this.couponsUrl}?percentage_off=${percentageOff}`;
    return this.httpClient
      .post(url, {}, { headers: this.httpHeaders })
      .toPromise()
      .then((res) => res)
      .catch(this.handleError);
  }

  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
